"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BusinessValuationRefineModal;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _BusinessValuationModalFormControls = require("./BusinessValuationModalFormControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BusinessValuationRefineModal(props) {
  var {
    handleClose,
    snapshot,
    show
  } = props;

  // Pulling formik context from higher up, which gives us access to formik state
  var {
    errors,
    touched,
    values,
    isSubmitting,
    isValid
  } = (0, _formik.useFormikContext)();
  var handleSubmit = e => {
    e.preventDefault();
    handleClose();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(snapshot),
    title: "Edit your inputs & our assumptions"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "My Business"), /*#__PURE__*/_react.default.createElement(_BusinessValuationModalFormControls.OwnersAveSalaryPast3YearsAmount, {
    values: values,
    errors: errors,
    touched: touched
  }), /*#__PURE__*/_react.default.createElement(_BusinessValuationModalFormControls.BusinessProfitAvePast3YearsAmount, {
    values: values,
    errors: errors,
    touched: touched
  }), /*#__PURE__*/_react.default.createElement(_BusinessValuationModalFormControls.NetBookValueAmount, {
    values: values,
    errors: errors,
    touched: touched
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "My Business Ownership"), /*#__PURE__*/_react.default.createElement(_BusinessValuationModalFormControls.BusinessPercent, {
    values: values,
    errors: errors,
    touched: touched
  }))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "link",
    onClick: () => handleClose(snapshot)
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    disabled: isSubmitting || !isValid,
    onClick: handleSubmit
  }, "Update"))));
}